import { useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'
import { axiosInstance } from '@/lib/axios'
import type { VehicleGroupModel } from '@/app/models/vehicle/vehicleGroupModel'

type Props = {
  companyId: string | undefined
  enabled?: boolean
}

/**
 * Fetches a company's vehicle groups. Replaces the imperative
 * `getVehicleGroups({ companyId })` + useState + useEffect pattern that
 * used to live inside VehiclesContext. Cached 10 minutes.
 */
export function useQueryVehicleGroups({ companyId, enabled = true }: Props) {
  return useQuery<VehicleGroupModel[]>({
    queryKey: ['vehicleGroups', String(companyId ?? '')],
    enabled: enabled && !!companyId,
    staleTime: MINUTE_IN_MS * 10,
    queryFn: async () => {
      const res = await axiosInstance.get(`/api/${companyId}/vehicle/groups`)
      return res.data ?? []
    },
  })
}
